import Breadcrumb from './../components/BreadCrumb';
import FAQ from './../sections/FaqSection';
import HeadingDetailsSection from './../sections/HeadingDetailsSection';

function FaqScreen() {
  return (
    <>
        <HeadingDetailsSection heading='FAQs'>
          <Breadcrumb screen='FAQs'/>
        </HeadingDetailsSection>
        <FAQ/>
    </>
  );
}

export default FaqScreen;
